import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFAppearanceIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const color = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.49992 15C11.6399 15 14.9999 11.64 14.9999 7.5C14.9999 3.36 11.6399 0 7.49992 0C3.35992 0 -7.70868e-05 3.36 -7.70868e-05 7.5C-7.70868e-05 11.64 3.35992 15 7.49992 15ZM8.24992 0.967333C11.2049 1.33483 14.0819 4.44 14.0819 7.5C14.0819 10.56 11.2124 13.5825 8.24992 13.95V0.967333Z'
        fill={color}
      />
    </svg>
  )
}
